// extracted by mini-css-extract-plugin
export var course_container = "index-module--course_container--kynC4";
export var card_body = "index-module--card_body--pa7JA";
export var card_price = "index-module--card_price--Q6Nre";
export var card_price_value = "index-module--card_price_value--Do95T";
export var coach = "index-module--coach--tDAIH";
export var profile = "index-module--profile--nU-5a";
export var img_container = "index-module--img_container--hdW8d";